import React, { Component } from 'react';
import Media from 'react-media';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { object, string, func } from 'prop-types';
import Card from '../../../../components/LazyWidgets/Card';
import Spinner from '../../../../components/LazyWidgets/Spinner';
import { fetchSkillsFeedbackSummaryReport, updateActiveFeedback } from '../../../actions/reports';
import s from './skillsFeedbackSummary.module.css';
import ReportError from '../ReportError';
import SkillsSummaryTable from '../../../../components/SkillsFeedbackTable/SkillsFeedbackTable';
import SkillsFeedbackSummaryDropdown from './components/SkillsFeedbackSummaryDropdown';
import ReportBreadcrumbs from '../../../../components/ReportBreadcrumbs/ReportBreadcrumbs';
import { withMatch } from '../../../../hoc';

class SkillsFeedbackSummary extends Component {
  static propTypes = {
    courseId: string,
    feedbackSummary: object,
    fetchSkillsFeedbackSummaryReport: func,
    updateActiveFeedback: func,
    match: object,
    onTabChange: func,
    reportTitle: string,
  };

  constructor(props) {
    super(props);

    this.tableStyle = [
      {
        row: 'styledRow',
        cells: [
          { accessor: 'name', alignment: 'left' },
          { accessor: 'numberOfInstructorComments', alignment: 'right' },
          { accessor: 'numberOfStudentReview', alignment: 'right' },
        ],
      },
    ];

    this.containerRef = React.createRef();
    this.adjustDropDowns = this.adjustDropDowns.bind(this);
    this.handleFeedbackUpdate = this.handleFeedbackUpdate.bind(this);
  }

  async componentDidMount() {
    const feedbackId = this.getItemIdFromProps(this.props);
    await this.fetchFeedbackSummaryReport(feedbackId);
  }

  async componentDidUpdate(prevProps) {
    const feedbackId = this.getItemIdFromProps(this.props);
    const prevFeedbackId = this.getItemIdFromProps(prevProps);
    if (feedbackId !== prevFeedbackId) {
      await this.fetchFeedbackSummaryReport(feedbackId);
    }
  }

  getItemIdFromProps(props) {
    return (props.match.params.itemId) ? props.match.params.itemId.split('#')[0] : null;
  }

  async fetchFeedbackSummaryReport(feedbackId) {
    await this.props.fetchSkillsFeedbackSummaryReport(feedbackId);
    if (this.props.feedbackSummary.activeFeedback) {
      this.props.onTabChange(`reports/type/skills-feedback-summary/${this.props.feedbackSummary.activeFeedback.id}`);
    }
    this.adjustDropDowns();
  }

  adjustDropDowns() {
    if (this.containerRef.current) {
      const dropDowns = this.containerRef.current.getElementsByTagName('select');
      for (const dropDown of dropDowns) {
        const fakeWidth = this.calculateFakeWidth(dropDown.options[dropDown.selectedIndex].textContent);
        if (fakeWidth > dropDown.offsetWidth + 3) {
          dropDown.parentElement.classList.add(s.ellipsis);
        }
      }
    }
  }

  calculateFakeWidth(text) {
    const tempDiv = document.createElement('div');
    document.body.appendChild(tempDiv);
    tempDiv.style.fontSize = '17px';
    tempDiv.style.position = 'absolute';
    tempDiv.style.left = -1000;
    tempDiv.style.top = -1000;
    tempDiv.style['white-space'] = 'nowrap';
    tempDiv.style.lineHeight = '32px';
    tempDiv.innerHTML = text;
    const width = tempDiv.clientWidth;
    document.body.removeChild(tempDiv);
    return width;
  }

  async handleFeedbackUpdate(newSelection) {
    await this.props.updateActiveFeedback(newSelection);
    if (this.props.feedbackSummary.activeFeedback) {
      this.props.onTabChange(`reports/type/skills-feedback-summary/${this.props.feedbackSummary.activeFeedback.id}`);
    }
  }

  renderSummary() {
    const {
      feedbackGoals,
      activeFeedback,
      feedbackData,
      loading,
      error,
    } = this.props.feedbackSummary;
    const breadcrumbItems = [
      { text: 'Overview', targetUrl: 'reports' },
      { text: this.props.reportTitle }];
    if (loading) return <Spinner className={s.spinner} />;
    if (error) return <ReportError />;
    let studentList = [];
    if (activeFeedback && feedbackData && feedbackData[activeFeedback.id] && feedbackData[activeFeedback.id].studentList) {
      studentList = feedbackData[activeFeedback.id].studentList;
    }
    return (
      <div ref={this.containerRef}>
        <h1 className={s.titleModule}>{this.props.reportTitle}</h1>
        <ReportBreadcrumbs
          items={breadcrumbItems}
          onTabChange={this.props.onTabChange}
        />
        <Card className={s.summaryCard}>
          <Media query="(max-width: 709px)">
            <SkillsFeedbackSummaryDropdown
              dropDownObject={feedbackGoals}
              activeDraft={activeFeedback}
              handleFeedbackUpdate={this.handleFeedbackUpdate}
            />
          </Media>
          <SkillsSummaryTable
            data={studentList}
            tableStyle={this.tableStyle}
          />
        </Card>
      </div>
    );
  }
  render() {
    return (
      <div className={s.summaryContainer}>
        {this.renderSummary()}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    feedbackSummary: state.reports.skills.feedbackSummary,
    reportTitle: state.reports.skills.feedbackSummary.reportTitle,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    fetchSkillsFeedbackSummaryReport: bindActionCreators(fetchSkillsFeedbackSummaryReport, dispatch),
    updateActiveFeedback: bindActionCreators(updateActiveFeedback, dispatch),
  };
}

export const ConnectedSkillsFeedbackSummary = connect(mapStateToProps, mapDispatchToProps)(SkillsFeedbackSummary);
export default withMatch(ConnectedSkillsFeedbackSummary);
